import OfficersList from './OfficersList.container';

export default OfficersList;
